<div class="row">
    <div class="col-3">
        <app-control label='Agency Approval Date' type="datetime" [isDisabled]="true" [(ngModel)]="agencyApprovalDate"/>                             
    </div>

    <div class="col-3">
        <app-control label="Agency Approved By" type="string" [isDisabled]="true" [ngModel]="agencyApprovedByFullName"/>                                
    </div>

    <div class="col-3">
        <app-control label='Dispatch Manager Approval Date' type="datetime" [isDisabled]="true" [(ngModel)]="dispatchApprovalDate"/>                             
    </div>

    <div class="col-3">
        <app-control label="Dispatch Manager Approved By" type="string" [isDisabled]="true" [ngModel]="dispatchApprovedByFullName"/>                                
    </div>

    <div class="col-3">
        <app-control label='Dispatch Shift Representative Approval Date' type="datetime" [isDisabled]="true" [(ngModel)]="dispatchShiftApprovalDate"/>                             
    </div>

    <div class="col-3">
        <app-control label="Dispatch Shift Representative Approved By" type="string" [isDisabled]="true" [ngModel]="dispatchShiftApprovedByFullName"/>                                
    </div>
</div>